import { CustomLoadingService } from 'src/app/shared/custom-loading/custom-loading.service';
import { Component, OnInit } from '@angular/core';
import { LicenseLiabilityService } from '../license-liability.service';

@Component({
  selector: 'app-licenses',
  templateUrl: './licenses.component.html',
  styleUrls: ['./licenses.component.css']
})
export class LicensesComponent  implements OnInit {
 
  inActiveLicenses: []
  activeLicenses: []
  title = "Licenses"
  constructor(private service: LicenseLiabilityService,
    private LoadingService: CustomLoadingService
  ) { }
  ngOnInit(): void {
    this.LoadingService.show();
    this.service.getLicenses().subscribe(res => {

    
      this.activeLicenses = res.Licenses.Active
      this.inActiveLicenses = res.Licenses.InActive



    }, (error) => {
            this.LoadingService.hide()
    },
      () => {
        this.LoadingService.hide()

      })
  }

}



